import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
interface DeleteAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  loading?: boolean;
}
export function DeleteAccountModal({
  isOpen,
  onClose,
  onConfirm,
  loading = false
}: DeleteAccountModalProps) {
  const [confirmText, setConfirmText] = useState('');
  const [understood, setUnderstood] = useState(false);
  if (!isOpen) return null;
  const isConfirmValid = confirmText === 'DELETE' && understood;
  const handleConfirm = async () => {
    if (!isConfirmValid) return;
    await onConfirm();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-1957" data-mp="15k9b5bdm6g8a">
      <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto" data-id="element-1958" data-mp="1al6p1brlco3z">
        <div className="p-6" data-id="element-1959" data-mp="2gzed2d5x8aqu">
          <div className="flex items-start justify-between mb-4" data-id="element-1960" data-mp="2h07ohrftrofb">
            <div className="flex items-center" data-id="element-1961" data-mp="2lyhjo21jup0x">
              <div className="bg-red-100 rounded-full p-2 mr-3" data-id="element-1962" data-mp="2m1dgfn1nv7ns">
                <AlertTriangle size={24} className="text-red-600" data-id="element-1963" data-mp="fas86tzdwekz" />
              </div>
              <h2 className="text-xl font-bold text-red-600" data-id="element-1964" data-mp="bbjj42fah4vr">Delete Account</h2>
            </div>
            <button onClick={onClose} disabled={loading} className="text-gray-400 hover:text-gray-600 disabled:opacity-50" data-id="element-1965" data-mp="6acay298i3ok">
              <X size={24} data-id="element-1966" data-mp="3sj57ck79fbdp" />
            </button>
          </div>
          <div className="mb-6" data-id="element-1967" data-mp="3skg8sdd8g71n">
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4" data-id="element-1968" data-mp="3nrdbbu5c4dg6">
              <p className="font-semibold text-red-900 mb-2" data-id="element-1969" data-mp="3jq1vggc9j6l6">
                ⚠️ This action cannot be undone
              </p>
              <p className="text-sm text-red-800" data-id="element-1970" data-mp="3es03f5wuzwxk">
                Deleting your account will permanently remove all of your data,
                including:
              </p>
            </div>
            <ul className="space-y-2 mb-4" data-id="element-1971" data-mp="34sr92by30gao">
              <li className="flex items-start text-sm text-gray-700" data-id="element-1972" data-mp="34tsv1bgmyn76">
                <span className="text-red-600 mr-2" data-id="element-1973" data-mp="2v4ndokm7d6y0">•</span>
                <span data-id="element-1974" data-mp="3048e6zh0tncu">All uploaded screenshots and conversation data</span>
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-1975" data-mp="2m4qlwa4inryq">
                <span className="text-red-600 mr-2" data-id="element-1976" data-mp="2m6jv9x6ikqaf">•</span>
                <span data-id="element-1977" data-mp="2q5kaz6tp3ct7">All toxicity analysis results and reports</span>
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-1978" data-mp="3dvem9jyd8tbc">
                <span className="text-red-600 mr-2" data-id="element-1979" data-mp="3iuzuym3c8g19">•</span>
                <span data-id="element-1980" data-mp="3iuhpcyuscpgo">Your account information and preferences</span>
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-1981" data-mp="352jkj083xfqb">
                <span className="text-red-600 mr-2" data-id="element-1982" data-mp="394oe5yyk2ccy">•</span>
                <span data-id="element-1983" data-mp="3933kebk2exg5">Your subscription and billing information</span>
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-1984" data-mp="o3cz4c60nke">
                <span className="text-red-600 mr-2" data-id="element-1985" data-mp="5h4ulk3rb17o">•</span>
                <span data-id="element-1986" data-mp="1q6icmmykj8cb">Access to all shared analysis links</span>
              </li>
            </ul>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4" data-id="element-1987" data-mp="1l7f8r5ubr85x">
              <p className="text-sm text-gray-700" data-id="element-1988" data-mp="1l5ch6hdix6z3">
                <strong data-id="element-1989" data-mp="1zv9zwhsop4gw">Note:</strong> If you have an active Pro subscription,
                it will be cancelled immediately. You will not be refunded for
                any remaining time in your billing period.
              </p>
            </div>
            <div className="mb-4" data-id="element-1990" data-mp="179h5owlgey5q">
              <label className="flex items-start cursor-pointer" data-id="element-1991" data-mp="129cof4cq1zeg">
                <input type="checkbox" checked={understood} onChange={e => setUnderstood(e.target.checked)} disabled={loading} className="mt-1 mr-3" data-id="element-1992" data-mp="12axg8m7nj48m" />
                <span className="text-sm text-gray-700" data-id="element-1993" data-mp="2sjo3re6gev0d">
                  I understand that this action is permanent and cannot be
                  undone. All my data will be permanently deleted.
                </span>
              </label>
            </div>
            <div data-id="element-1994" data-mp="123ddhjrqcdm1">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1995" data-mp="124wujcl7msov">
                Type <strong data-id="element-1996" data-mp="164yxdp2ols5q">DELETE</strong> to confirm
              </label>
              <input type="text" value={confirmText} onChange={e => setConfirmText(e.target.value.toUpperCase())} disabled={loading} placeholder="DELETE" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1997" data-mp="167tfh9y830vz" />
            </div>
          </div>
          <div className="flex gap-3" data-id="element-1998" data-mp="1tujk8j1yh9ka">
            <button onClick={onClose} disabled={loading} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1999" data-mp="1yu5see2xfzm8">
              Cancel
            </button>
            <button onClick={handleConfirm} disabled={!isConfirmValid || loading} className="flex-1 px-4 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2000" data-mp="28xt9otrlpxiz">
              {loading ? 'Deleting...' : 'Delete Account'}
            </button>
          </div>
          <p className="text-xs text-gray-500 text-center mt-4" data-id="element-2001" data-mp="2ro2emberw3ed">
            Need help? Contact us at{' '}
            <a href="mailto:toxicdetector25@gmail.com" className="text-purple-600 hover:underline" data-id="element-2002" data-mp="2mx2eyye9r786">
              toxicdetector25@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>;
}